/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const CheckIcon = createIcon({
    displayName: 'CheckIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.2393 9.05513C17.8297 10.9534 16.2497 12.9589 14.4545 15.0713C13.0146 16.7668 11.5951 18.3366 10.2113 19.7984L9.75202 20.2835L9.26898 19.822C8.54419 19.1296 7.77045 18.3177 6.98271 17.3924L6.9812 17.3907C6.11684 16.3681 5.37449 15.3698 4.7439 14.4379L5.84542 13.6925C6.4515 14.5882 7.1652 15.5481 7.9962 16.5312C8.58194 17.2192 9.15819 17.8403 9.70885 18.3918C10.9306 17.087 12.178 15.6973 13.4407 14.2104C15.2162 12.1212 16.7784 10.1384 18.1715 8.26221L19.2393 9.05513Z"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "M8.63011 21.43L7.90011 20.73C6.74011 19.62 5.58011 18.39 4.47011 17.09C3.27011 15.67 2.14011 14.18 1.11011 12.66L2.77011 11.54C3.76011 13 4.85011 14.44 6.00011 15.8C6.84011 16.78 7.70011 17.72 8.57011 18.59C10.5301 16.5 12.3701 14.44 14.1701 12.32C16.6501 9.39999 19.0401 6.39999 21.2701 3.39999L22.8801 4.58999C20.6201 7.62999 18.2101 10.67 15.7001 13.61C13.6701 16.01 11.5801 18.33 9.34011 20.7L8.63011 21.43Z"
        })
    ]
});
CheckIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'CheckIcon'
};
export { CheckIcon };

//# sourceMappingURL=check.js.map